import { useState } from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import axios from 'axios';

import SecurityPageWrapper from '../../security/security-page-wrapper/SecurityPageWrapper';
import EmailSent from './components/EmailSent';
import RequestForm from './components/RequestForm';
import validate from '../../utils/validate';
import { requestAdImagesYopValidation } from './validation';
import sendRequest from '../../service/sendRequest';
import { enqueueSnackbar, somethingWrongNotification } from '../../redux/notifier/notifierActions';

const AdImagesRequest = () => {
  const dispatch = useDispatch();
  const [sentEmail, setSentEmail] = useState(false);

  const requestAdImagesInitialValues = {
    email: '',
    userName: '',
    companyName: '',
  };

  const handleRequestAdImages = async (values) => {
    const { email, userName, companyName } = values;
    await await sendRequest(
      () => axios.post(`/api/consumer/id8/demo/recreate/register`, { email, userName, companyName }),
      {
        onError: (e) => requestErrorHandler(e, dispatch),
      },
    );

    setSentEmail(true);
  };

  return (
    <SecurityPageWrapper backgroundStyle='otp'>
      {sentEmail ? (
        <EmailSent />
      ) : (
        <Form
          initialValues={requestAdImagesInitialValues}
          onSubmit={handleRequestAdImages}
          subscription={{ submitting: true, pristine: true }}
          validate={(values) => validate(values, requestAdImagesYopValidation())}
          render={({ handleSubmit }) => <RequestForm onSubmit={handleSubmit} />}
        />
      )}
    </SecurityPageWrapper>
  );
};

export default AdImagesRequest;

const requestErrorHandler = (e, dispatch) => {
  if (e.response.status === 409) {
    dispatch(
      enqueueSnackbar({
        message: e.response.data,
        options: {
          variant: 'error',
        },
      }),
    );

    return null;
  }

  if (e.response.status === 400) {
    dispatch(
      enqueueSnackbar({
        message: 'invalidData',
        options: {
          variant: 'error',
        },
      }),
    );
    return null;
  }

  dispatch(somethingWrongNotification());
  return null;
};
